import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LoaderService } from '@teem/app/core/services/loader.service';
import { ProfileService } from '@teem/app/core/services/profile.service';
import { SearchCountryField, CountryISO, PhoneNumberFormat } from 'ngx-intl-tel-input';
// import { SigninModalComponent } from '@teem/customer/modals/signin-modal/signin-modal.component';
import { environment } from '@teem/environments/environment';
import { CustomerAuthService } from '@teem/app/core/services/customer-auth.service';
import { SharedDataService } from '@teem/app/core/services/shared-data.service';
import Swal from 'sweetalert2';
import { messages as i18n } from '@teem/constants/messages';
@Component({
	selector: 'signup-modal',
	templateUrl: './signup-modal.component.html',
	styleUrls: ['./signup-modal.component.scss']
})
export class SignupModalComponent {
	@Output() authState = new EventEmitter<string>();
	signupForm: FormGroup;
	isSubmitted: boolean = false;

	separateDialCode = true;
	SearchCountryField = SearchCountryField;
	CountryISO = CountryISO;
	PhoneNumberFormat = PhoneNumberFormat;
	input : any  = '';
	preferredCountries: CountryISO[] = [CountryISO.SaudiArabia, CountryISO.UnitedArabEmirates, CountryISO.Kuwait, CountryISO.Bahrain, CountryISO.UnitedStates, CountryISO.UnitedKingdom];

	constructor(
		private fb: FormBuilder,
		private modalService: NgbModal,
		public activeModal: NgbActiveModal,
		private loaderService : LoaderService,
		private profileService: ProfileService,
		private customerAuthService: CustomerAuthService,
		private sharedDataService: SharedDataService
	) {
		this.signupForm = this.fb.group({
			email: ['', [Validators.required, Validators.email]],
			password: ['', [Validators.required, Validators.minLength(6)]],
			first_name: ['', [Validators.required, Validators.minLength(3)]],
			last_name: ['', [Validators.required, Validators.minLength(3)]],
			dob: ['', [Validators.required]],
			passwordConfirm: ['', [Validators.required]],
			phone: ['', [Validators.required]],
		}, { validators: this.passwordMatchValidator });
	}

	ngOnInit(): void {

	}

	authToggle(state: string) {
		this.authState.emit(state);
	}

	openDatePicker(event: Event): void {
		this.input = event.target as HTMLInputElement;
		if (this.input.showPicker) {
			this.input.showPicker(); // Supported in Chrome
		}
	}

	passwordMatchValidator(control: AbstractControl): { [key: string]: boolean } | null {
		const password = control.get('password')?.value;
		const confirmPassword = control.get('passwordConfirm')?.value;
		if (password && confirmPassword && password !== confirmPassword) {
			control.get('passwordConfirm')?.setErrors({ mismatch: true });
			return { mismatch: true };
		}
		return null;
	}

	onSubmit() {
		this.isSubmitted = true;
		if (this.signupForm.valid) {
			const loginData = {
				'email': this.signupForm.get('email').value, 
				'password': this.signupForm.get('password').value,
				'phone' : this.signupForm.get('phone').value,
				'first_name' : this.signupForm.get('first_name').value,
				'last_name' : this.signupForm.get('last_name').value,
				'dob' : this.signupForm.get('dob').value
			}
			this.loaderService.startLoading();
			this.profileService.singup(loginData).subscribe({
				next: (res:any) => {
					this.loaderService.stopLoading();
					this.customerAuthService.login();
					this.activeModal.close(res);
					Swal.fire(i18n.alert.success, i18n.signup.completed, 'success');
					if(res.intended_url?.includes("checkout")){
						window.location.href = res.intended_url;
					}else{
						window.location.reload();
					}
				},
				error: (err) => {
					this.loaderService.stopLoading();
					const errors = err.error?.errors;
					console.log(errors);
					if (errors?.email) {
						this.signupForm.get('email')?.setErrors({ serverError: errors.email[0] });
					}

					if (errors?.phone) {
						this.signupForm.get('phone')?.setErrors({ serverError: errors.phone[0] });
					}
				},
			});
		}else {
			this.signupForm.markAllAsTouched(); // Show errors if form is invalid
		}
	}

	openSignInModal(): void {
		this.activeModal.close({});
		// const modalRef = this.modalService.open(SigninModalComponent, {
		// 	backdrop: 'static',
		// 	keyboard: false
		// });
	}

	closeSignup() {
		this.activeModal.close({});
		this.openSignInModal();
	}
}